import styles from './team.module.css';
import { team } from './data';
import TeamCard from './team-card';
import {
  Container,
  Htag,
  HtagAlign,
  HtagVariant,
  Notification,
} from '../../components';

export default function Team() {
  return (
    <div className={styles.page}>
      <Container>
        <section className={styles.team}>
          <Htag
            variant={HtagVariant.h2}
            tag="h1"
            align={HtagAlign.center}
            className={styles.title}
          >
            OUR AMAZING TEAM
          </Htag>
          <ul>
            {team.map(({ teamBlocks }) => (
              <li className={styles['team-item']}>
                <div className={styles['team-item__inner']}>
                  {teamBlocks.map((teamCard, index) => (
                    <TeamCard key={index} {...teamCard} />
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </section>
        <section className={styles.about}>
          <h2 className={styles.about_title}>About Us</h2>
          <div className={styles.about_text}>
            <p>
              Now you know us a little closer, thanks to the portraits above! We
              are always happy to meet new people, learn their interests,
              dreams. We feel that our mission is to help achieve any goals. The
              team is not afraid of difficulties, because we love to improve
              with each completed task.
            </p>
            <br />
            <p>
              Since 2017, we have been growing, expanding and do not see the
              boundaries of the possible. Our team members are like one family,
              which together is stronger than alone. Experience and knowledge
              allow us to see the problem more widely and solve it in the best
              way.
            </p>
            <br />
            <p>To do great things, we just need to start. Join us!</p>
          </div>
        </section>
        <Notification
          title="HAVE A PROJECT IN MIND?"
          buttonName="Contact us"
          href="/contact"
          className={styles.notification}
        />
      </Container>
    </div>
  );
}
